module.exports = __webpack_public_path__ + "static/media/55.fbee5f8c.jpg";